import { Fragment, useState, useRef, useEffect } from "react";
import { Navigate, NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { formatDate } from "../lib/utils";
import { List } from "./list";
import { Button } from "@progress/kendo-react-buttons";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const reportItemRenderer = (currentTheme, isClient, t) => (props, item, index) => {   
    return (
        <div key={item.Id} className={`list-item`} onDoubleClick={e => {}}>
            {/* <div style={{paddingLeft:20}} className={`list-item-data-type-icon k-icon k-i-edit `}></div> */}
            <div className="list-item-title" style={{fontWeight: `${item.IsSystem ? 700 : 400}`}}>{item.Title}</div>       
            { 
                props.canView && !isClient &&
                <Button disabled={false} title={t("reportsviewer.addremove")}
                     style={{border: "none", color: currentTheme.touchColor, backgroundColor: "transparent"}} 
                    icon={`${item.IsFavorite ? "favorite" : "favorite-outline" }`} onClick={e => props.onSetFavorite(item.Id)}></Button>        
            }
            <div className="list-item-view">    
            {
                item.CanView &&
                <Button disabled={false} title={t("reportsviewer.view")}
                     style={{border: "none", color: currentTheme.touchColor, backgroundColor: "transparent"}} 
                    icon="eye" onClick={e => props.navigate(`/reportingview/${item.ReferenceKey}`)}></Button>
            }
            </div>
            <div className="list-item-edit">
            {
                props.canEdit && //!isClient &&
                <Button disabled={false} title={t("reportsviewer.design")}
                    style={{border: "none", color: currentTheme.touchColor, backgroundColor: "transparent"}} 
                    icon="edit" onClick={e => props.navigate(`/reportingdesign/${item.ReferenceKey}`)}></Button>
            }
            </div>
            <div className="list-item-delete">
            {
                props.canDelete && !isClient &&
                <Button disabled={false} title={t("reportsviewer.delete")}
                    style={{border: "none", color: currentTheme.error, backgroundColor: "transparent"}} 
                    icon="delete" onClick={e => props.onDelete(item.ReferenceKey)}></Button>
            }
            </div>  
        </div>      
    );  
};

// const ReportItem = props => {
//     const { item, canCreate, canEdit, canDelete, onDelete, onSetFavorite, ...other} = props;

//     const currentTheme = useSelector(state => state.currentTheme);

//     return (
//         <Fragment>
//             <List />

//             <div key={item.Id} className={`report-item`}>
//                 <div className="item-top">
//                     <div className="item-left">
//                         <img style={{padding: item.ImagePadding}} src={item.ImagePath} />
//                     </div>
//                     <div className="item-right">
//                         <div className="title">
//                             {props.itemIndex} - {item.Title}
//                         </div>
//                         <div className="info">
//                             {formatDate(item.CreatedOn, "mmm-dd-yyyy HH:MM")}
//                         </div>
//                     </div>
//                 </div>
//                 <div className="item-bottom">                   
//                     <div className="menu-bar">
//                         {
//                             item.CanView && 
//                             <div className="action">
//                                 <NavLink to={`/reportingview/${item.ReferenceKey}`}>
//                                     <div className="view k-icon k-i-eye" title="View Report"></div>
//                                 </NavLink>
//                             </div>
//                         }
//                         {
//                             canEdit && 
//                             <div className="action">
//                                 <NavLink to={`/reportingdesign/${item.ReferenceKey}`}>
//                                     <div className="edit k-icon k-i-edit" title="Edit Report"></div>
//                                 </NavLink>
//                             </div>
//                         }
//                             <div className="action">
//                                 <div className={`fav k-icon ${!item.IsFavorite ? 'k-i-fav-outline' : 'k-i-fav'}`} title={`${item.IsFavorite ? 'Favorite' : 'Not Favorite'}`} onClick={e => onSetFavorite(item.Id)}></div>
//                             </div>
//                         {
//                             canDelete && 
//                             <div className="action">
//                                 <div className="delete k-icon k-i-delete" title="Delete Report" onClick={e => onDelete(item.ReferenceKey)}></div>
//                             </div>
//                         }
//                     </div>
//                 </div>
//             </div>
//             <style>
//                 {
//                     `
//                     .report-item
//                     {
//                         display: flex;
//                         flex-direction: column;                      
//                         border: 1px solid ${currentTheme.separatorColor};
//                         border-radius: 6px;
//                         width: 45%;
//                         margin:22px 0;
//                     }

//                     .report-item .item-top
//                     {
//                         flex: 1;
//                         display: flex;
//                         align-items: stretch;
//                     }

//                     .report-item .item-top .item-left
//                     {
//                         padding: 4px 16px;
//                     }

//                     .report-item .item-top .item-left img
//                     {
//                         width: 80px;
//                         height: auto;                       
//                         aspect-ratio: 4 / 3;
//                     }

//                     .report-item .item-right
//                     {
//                         display: flex;
//                         flex-direction: column;
//                         flex: 1;
//                         border-left: 1px solid ${currentTheme.separatorColor};
//                         overflow: hidden;
//                     }

//                     .report-item .item-right .title
//                     {
//                         font-size: 14px;
//                         padding: 8px 8px;
//                         width: 100%;
//                         flex: 1;
//                         white-space: nowrap;
//                         overflow: hidden;
//                         text-overflow: ellipsis;
//                         color: ${currentTheme.componentText};
//                         font-weight: 500;
//                     }

//                     .report-item .item-right .info
//                     {
//                         font-size: 14px;
//                         padding: 8px 8px;
//                         width: 100%;
//                         white-space: nowrap;
//                         overflow: hidden;
//                         text-overflow: ellipsis;
//                         color: ${currentTheme.componentText};
//                         border-top: 1px dashed ${currentTheme.separatorColor};
//                     }

//                     .report-item .item-bottom{
//                         display: flex;
//                     }

//                     .report-item .item-bottom .menu-bar
//                     {
//                         border-top: 1px solid ${currentTheme.separatorColor};
//                         flex: 1;
//                         display: flex;
//                         justify-content: space-between;
//                         align-items: center;
                        
//                     }

//                     .report-item .item-bottom .menu-bar .action
//                     {
//                         flex:1;
//                         padding: 10px 0;
//                         display: flex;
//                         justify-content: center;
//                         align-items: center;
//                         color: ${currentTheme.componentText};
//                     }

//                     .report-item .item-bottom .menu-bar .action a
//                     {
//                         text-decoration: none;
//                         color: ${currentTheme.componentText}!important;
//                     }

//                     .report-item .item-bottom .menu-bar .action a:visited
//                     {
//                         color: ${currentTheme.componentText}!important;
//                     }

//                     .report-item .item-bottom .menu-bar .action:hover .k-icon
//                     {
//                         color: ${currentTheme.touchColor};
//                         cursor: pointer;
//                     }

//                     `
//                 }
//             </style>
//         </Fragment>
//     );
// };

export const ReportsViewer = props => {

    const { canCreate, canEdit, canDelete, onDelete, onSetFavorite, ...other} = props;

    const currentTheme = useSelector(state => state.currentTheme);
    const currentUser = useSelector(state => state.currentUser);
    const pageState = useSelector(state => state.reportingLocatorPage);
    const navigate = useNavigate();
    const { t } = useTranslation();

    const filter = pageState.filter;
    const showSystemEntities = pageState.showSystemEntities;

    const filteredItems = pageState.items.filter(e => {
        if ((!filter || filter.trim() == "") && showSystemEntities)
            return true;
                
        if ((!filter || filter.trim() == ""))//do not show system entities
            return e.IsSystem == false;
        
        //i am here => there is text
        const trimmedFilter = filter.toLowerCase();

        if (showSystemEntities)
            return e.Title.toLowerCase().indexOf(trimmedFilter) >= 0;
        else
            return e.Title.toLowerCase().indexOf(trimmedFilter) >= 0 && e.IsSystem == false;    
    });
    
    return (
        <Fragment>
            <div className={"reports-viewer"}>
                {
                    filteredItems?.length > 0 &&
                    <List className="reports-viewer-list" navigate={navigate}
                    items={filteredItems} 
                    canCreate={canCreate} canEdit={canEdit} canDelete={canDelete} onSetFavorite={onSetFavorite} onDelete={onDelete}
                    itemRenderer={reportItemRenderer(currentTheme, currentUser.ClientId, t)} />
                }
            </div>
            <style>
                {
                    `
                    .reports-viewer
                    {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        align-items: flex-start;
                        align-content: start;
                        flex: 1;
                        overflow: auto;
                        padding: 8px 26px;
                    }

                    .reportinglocator-page .reports-viewer .reports-viewer-list
                    {
                        border: 1px dotted ${currentTheme.separatorColor}; 
                        border-radius: 8px;
                        margin-top: 24px;
                        min-width: 700px;
                        width: 100%;
                        height: calc(100% - 46px);
                        padding: 0px 0px 0px 0px;
                    }

                    .reportinglocator-page .reports-viewer .reports-viewer-list .list-root
                    {
                        border-collapse: collapse;
                    }

                    .reportinglocator-page .reports-viewer .reports-viewer-list .list-item
                    {
                        line-height: 3;
                        border-top: 1px solid ${currentTheme.componentBorderColor}; 
                        border-radius: 6px;
                    }

                    .reportinglocator-page .reports-viewer .reports-viewer-list .list-item:first-child
                    {
                        border-top: none;
                    }

                    .reportinglocator-page .reports-viewer .reports-viewer-list .list-item:last-child
                    {
                        border-bottom: 1px solid ${currentTheme.componentBorderColor}; 
                    }

                    .reportinglocator-page .reports-viewer .reports-viewer-list .list-item:hover
                    {
                      background-color: ${currentTheme.componentBorderColor};
                      cursor: pointer;
                    }

                    .reportinglocator-page .reports-viewer .reports-viewer-list .list-item-title
                    {
                        width: 100%;
                        vertical-align: middle;
                        padding-left: 12px;
                    }

                    @media (max-width: 1024px) {
                      .reportinglocator-mobile-view .reports-viewer {
                        height: auto;
                        padding: 0;
                        overflow: visible;
                      }

                      .reportinglocator-mobile-view .reports-viewer .reports-viewer-list {
                        display: block;
                        min-width: 0;
                        height: auto;
                        margin-top: 0;
                        overflow: visible;
                      }

                      .reportinglocator-mobile-view .reports-viewer .reports-viewer-list .list-root {
                        display: block;
                      }

                      .reportinglocator-mobile-view .reports-viewer .reports-viewer-list .list-item {
                        display: flex;
                        align-items: center;
                        padding: 12px;
                        border-radius: 0;
                        line-height: normal;
                      }

                      .reportinglocator-mobile-view .reports-viewer .reports-viewer-list .list-item-title {
                        flex: 1;
                        min-width: 0;
                        overflow-wrap: anywhere;
                        padding-left: 0;
                      }

                      .reportinglocator-mobile-view .reports-viewer .reports-viewer-list .list-item > .k-button,
                      .reportinglocator-mobile-view .reports-viewer .reports-viewer-list .list-item-view {
                        flex: 0 0 auto;
                      }

                      .reportinglocator-mobile-view .reports-viewer .reports-viewer-list .list-item .list-item-edit,
                      .reportinglocator-mobile-view .reports-viewer .reports-viewer-list .list-item .list-item-delete {
                        display: none !important;
                      }
                    }
                    
                    `
                }
            </style>
        </Fragment>
    );
};
